import { render, staticRenderFns } from "./SubscriptionFollowDialog.vue?vue&type=template&id=11c820c9&scoped=true&"
import script from "./SubscriptionFollowDialog.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFollowDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFollowDialog.vue?vue&type=style&index=0&id=11c820c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c820c9",
  null
  
)

export default component.exports